import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

export interface TooltipProps
  extends Pick<TooltipPrimitive.TooltipProps, 'open' | 'defaultOpen' | 'onOpenChange' | 'delayDuration'> {
  content: React.ReactNode;
  children: React.ReactNode;
  side?: TooltipPrimitive.TooltipContentProps['side'];
  align?: TooltipPrimitive.TooltipContentProps['align'];
  sideOffset?: number;
  className?: string;
}

/* Inverted surface instead of a bordered panel: a tooltip that matches the page
   chrome is hard to separate from the menus it so often opens next to. */
const Tooltip = ({
  content,
  children,
  side = 'top',
  align = 'center',
  sideOffset = 6,
  delayDuration = 120,
  className,
  ...props
}: TooltipProps) => (
  <TooltipPrimitive.Root delayDuration={delayDuration} {...props}>
    <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        side={side}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 max-w-[260px] animate-slide-up-fade rounded-[6px] bg-ink px-2 py-1 text-xs text-canvas shadow-pop',
          className,
        )}
      >
        {content}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  </TooltipPrimitive.Root>
);
Tooltip.displayName = 'Tooltip';

export { Tooltip, TooltipProvider };
